import { EVENT_CHATS_TYPES } from '@/modules/Events/constants.js';

export default {
  chat_types: {
    [EVENT_CHATS_TYPES.members]: 'участников',
    [EVENT_CHATS_TYPES.organizators]: 'организаторов',
    [EVENT_CHATS_TYPES.experts]: 'экспертов',
  },
};
